import React from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import BitbucketBranchesIcon from '@atlaskit/icon/glyph/bitbucket/branches';
import { B400 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import Link from '@atlassian/jira-common-analytics-v2-wrapped-components/src/link';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';
import type { Props } from './types';

const ListSchemes = ({
	schemes,
	getUrl,
	onLinkClickHandleAnalytics,
	getAnalyticsContainers,
}: Props) => (
	<ListWrapper>
		{schemes.map((scheme) => (
			<ItemWrapper key={scheme.id}>
				<BitbucketBranchesIcon
					primaryColor={token('color.icon.brand', B400)}
					label="scheme"
					size="small"
				/>
				{getAnalyticsContainers ? (
					<ContextualAnalyticsData containers={getAnalyticsContainers(scheme)}>
						<Link
							href={getUrl(scheme)}
							// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
							onClick={(_, analyticsEvent) => {
								if (onLinkClickHandleAnalytics != null) {
									onLinkClickHandleAnalytics(analyticsEvent);
								}
							}}
						>
							{scheme.name}
						</Link>
					</ContextualAnalyticsData>
				) : (
					<Link
						href={getUrl(scheme)}
						// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
						onClick={(_, analyticsEvent) => {
							if (onLinkClickHandleAnalytics != null) {
								onLinkClickHandleAnalytics(analyticsEvent);
							}
						}}
					>
						{scheme.name}
					</Link>
				)}
			</ItemWrapper>
		))}
	</ListWrapper>
);

export default ListSchemes;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ListWrapper = styled2.div({
	display: 'flex',
	flexDirection: 'column',
	boxSizing: 'border-box',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	minHeight: `${6 * gridSize}px`,
	paddingBottom: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ItemWrapper = styled.div({
	alignItems: 'center',
	display: 'flex',
	marginBottom: token('space.100', '8px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:last-child': {
		marginBottom: 0,
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	maxWidth: `${38 * gridSize}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	span: {
		alignSelf: 'flex-start',
		paddingTop: token('space.025', '2px'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	a: {
		paddingLeft: token('space.050', '4px'),
	},
});
